import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { Slot } from "radix-ui";
import { cn } from "../lib/cn.js";
export const buttonVariants = cva("inline-flex shrink-0 items-center justify-center gap-2 rounded-lg text-sm font-medium whitespace-nowrap transition-[color,background-color,border-color,box-shadow] outline-none select-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background active:translate-y-px disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/70",
            soft: "bg-primary-soft text-primary hover:bg-primary/15",
            outline: "border border-input bg-card shadow-xs hover:bg-accent hover:text-accent-foreground",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            destructive: "bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "h-10 px-4 py-2",
            xs: "h-7 rounded-md px-2 text-xs [&_svg]:size-3.5",
            sm: "h-8 rounded-md px-3",
            lg: "h-11 px-6 text-base",
            icon: "size-10",
        },
    },
    defaultVariants: { variant: "default", size: "default" },
});
export function Button({ className, variant, size, asChild = false, ...props }) {
    const Component = asChild ? Slot.Root : "button";
    return _jsx(Component, { className: cn(buttonVariants({ variant, size }), className), ...props });
}
//# sourceMappingURL=button.js.map